import React from "react";
import "../privacy-policy/privacy-policy.m.css";
const Liitannaisten = () => {
  return (
    <div styleName="container">
      <div styleName="hero-image">
        <img src="https://s3-alpha-sig.figma.com/img/1c4c/1c56/077c2920d9ec8655d049089c2dfacbc7?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dG6Kpz7yVoaNo4Xqy0f~Zu-YtharChBXABuKbes3TgZwcP~mkvxCeaaex5IesfogwariSqGsTKGdpeHwW2nBJmzm0ZHLRjtTsEKkKUq7vcu69Nxva9~fXL1EZ68PXfl0j332mspOqULI57~zbGXa-~kmf40fq631-v3SLbq4BoUbLj5zjXadGFp0G-fA5c2XMg2Dn0obIbafLT0hqVUWtKST3QEGdbogMiF-f0APZbKDEJYuOC2vURfNCxkwy4hRvYN-FQYW52uCc4BHlpFCQ~LoroQkHZaGXqnhHb~wTf6W3j7cfNWpj01HCtMTLKPZCKpn3R71mq9NTsigVulloA__" />
        <h1 styleName="header-one">Liitännäisten tietosuojakuvaus</h1>
      </div>
      <div styleName="lower-container">
        <p>
          <strong>Päivitetty:</strong> 1.4.2025
        </p>

        <h2 styleName="header-two">1. Kolmannen osapuolen palvelut ja teknologiat</h2>

        <p>
          Dei Plus käyttää kolmannen osapuolen palveluita ja teknologioita palvelun toiminnan ja käyttäjäkokemuksen
          parantamiseksi. Näitä voivat olla mm. analytiikkatyökalut, mainosratkaisut, sosiaalisen median jakopainikkeet
          sekä sisällönhallintaan liittyvät teknologiat.
        </p>
        <div styleName="contact-box">
          <h2 styleName="header-two">Esimerkkejä käytettävistä palveluista:</h2>
          <ul>
            <li>Analytiikka ja kävijäseuranta: Google Analytics</li>
            <li>Markkinointi ja mainonta: Google Ads Conversion Tracking, Facebook Pixel</li>
            <li>Sosiaalisen median liitännäiset: Facebook ja Instagram Social Plugins, Twitter (X) Embed</li>
            <li>Evästehallinta ja käyttäjäsuostumus: Google Consent Mode, Cookiebot</li>
            <li>Maksujärjestelmät: PayTrail</li>
          </ul>
        </div>

        <h2 styleName="header-two">2. Käytettävät evästeet</h2>
        <div styleName="contact-box">
          <h2 styleName="header-two">Palvelussa käytetään seuraavanlaisia evästeitä:</h2>
          <ul>
            <li>
              Välttämättömät evästeet: Tarpeellisia verkkosivuston perustoimintojen ja turvallisuuden varmistamiseksi.
            </li>
            <li>Toiminnalliset evästeet: Parantavat käyttäjäkokemusta esimerkiksi muistamalla käyttäjän asetukset.</li>
            <li>
              Analytiikkaevästeet: Keräävät tietoa palvelun käytöstä ja auttavat kehittämään sitä (esim. Google
              Analytics).
            </li>
            <li>
              Markkinointi- ja mainosevästeet: Mahdollistavat kohdennetun mainonnan ja muun markkinointiviestinnän
              (esim. Google Ads, Facebook Pixel).
            </li>
          </ul>
        </div>
        <h2 styleName="header-two">3. Käytettävät evästeet</h2>
        <div styleName="contact-box">
          <h2 styleName="header-two">Evästeitä käytetään seuraaviin tarkoituksiin:</h2>
          <ul>
            <li>Palvelun toiminnan varmistaminen ja käytettävyyden parantaminen.</li>
            <li>Käyttäjäkokemuksen mukauttaminen ja personointi.</li>
            <li>Käyttäjien käyttäytymisen analysointi palvelun kehittämiseksi.</li>
            <li>Kohdennetun mainonnan ja markkinoinnin toteuttaminen.</li>
          </ul>
        </div>
        <h2 styleName="header-two">4. Tietojen säilytys</h2>
        <div>
          <p>
            Kerätyt tiedot säilytetään palvelimilla, jotka sijaitsevat joko EU:n alueella tai EU:n
            tietosuojalainsäädännön mukaisia riittäviä tietosuojatoimia noudattavissa maissa. Kolmansien osapuolten
            tarjoamien palveluiden osalta tietoja voidaan säilyttää myös palveluntarjoajien omilla palvelimilla heidän
            tietosuojakäytäntöjensä mukaisesti.
          </p>
        </div>
        <h2 styleName="header-two">5. Google Consent Mode</h2>
        <div>
          <p>
            Dei Plus käyttää Google Consent Mode -toimintoa, jonka avulla evästeiden ja tietojen keruu mukautetaan
            käyttäjän suostumusten perusteella. Tämä tarkoittaa, että esimerkiksi analytiikka- ja mainosevästeitä ei
            aseteta ennen kuin käyttäjä on antanut{" "}
          </p>
        </div>
        <h2 styleName="header-two">6. Evästeiden hallinta</h2>
        <div>
          Käyttäjä voi hallita ja muuttaa evästeasetuksiaan milloin tahansa verkkosivuston evästeasetusten hallinnan
          kautta. Lisäksi evästeet voi poistaa tai estää selaimen asetuksista, mutta tämä voi vaikuttaa palvelun
          toiminnallisuuteen.
        </div>

        <div styleName="contact-box">
          <p>
            <strong>Yhteystiedot:</strong>
          </p>
          <p>Radio Dei, Mannerheimintie 105, 00280 HELSINKI</p>

          <p>Mikäli sinulla on kysyttävää tietosuojakäytännöistämme, voit ottaa yhteyttä:</p>

          <p>
            Sähköposti: <a href="mailto:asiakaspalvelu@radiodei.fi">asiakaspalvelu@radiodei.fi</a>
          </p>
        </div>
      </div>
    </div>
  );
};
export { Liitannaisten };
